// loads scripts that need to be on page - every entrypoint should import this!
// import './kickstart';

import { initFrameAndPoll } from '@newswire/frames';
import { loadAnimation } from './bodymovin/bodymovin';

initFrameAndPoll();

var x = document.getElementById("bonnie");
var play = document.getElementById ("play");
var pause = document.getElementById ("pause");

play.addEventListener ("click", function(){ 
									x.play(); 
									playAnimation(); 
									play.classList.add("hidden");
									pause.classList.remove("hidden"); });


pause.addEventListener ("click", function(){ 
									x.pause(); 
									pauseAnimation(); 
									pause.classList.add("hidden");
									play.classList.remove("hidden"); });

// Write your code!
var animation = loadAnimation({
  container: document.getElementById('bm'),
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: dataSrc
})
 
animation.addEventListener("complete", function(){ 
												animation.goToAndStop(0) 
												pause.classList.add("hidden");
												play.classList.remove("hidden"); });


function playAnimation(){
	animation.play();
}

function pauseAnimation(){
	animation.pause();
}

